// extracted by mini-css-extract-plugin
module.exports = {"ring":"ProgressRing_ring__oIj5G","text":"ProgressRing_text__RinvA","overflow":"ProgressRing_overflow__OaQrY"};